module.exports = __webpack_public_path__ + "static/img/34.4ce1141.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/digitalize/34.png
// module id = lzwm
// module chunks = 2